import React, { useEffect } from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import ModalDialog from '../../../shared/components/modals/modal-dialog/modal-dialog'
import { documentToReactComponents } from '@contentful/rich-text-react-renderer'
import { BLOCKS } from '@contentful/rich-text-types'
import { baseSiteUrl } from '../../../shared/utils/siteUrl'
import Button from '../../../shared/components/atoms/button/button'
import './modal-age-error.scss'
import { pushDataLayerEvent } from '../../../shared/utils/metricManagementUtil'
import { encryptUserInfo } from '../../../shared/utils/encryptUserInfo'

const ModalAgeError = ({ onClose }) => {
  const {
    allContentfulVConfidentComponentesTransversales: { nodes: content },
  } = useStaticQuery(graphql`
    {
      allContentfulVConfidentComponentesTransversales(
        filter: { titulo: { eq: "Modal > Advertencia de Edad" } }
      ) {
        nodes {
          titulo
          descripcinComponente {
            raw
          }
          imagenComponente {
            gatsbyImageData
          }
          botonComponente
        }
      }
    }
  `)

  const dataLayerModalError = () => {
    const userInfoEncrypt = encryptUserInfo()
    pushDataLayerEvent({
      event: 'Interacciones_Pop-ups_VConfident',
      category: 'v-confident',
      action: 'view',
      label: 'Aún no has llegado a esta etapa de tu vida',
      location: typeof window !== 'undefined' ? window.location.href : '',
      user_data: userInfoEncrypt.user_data ? userInfoEncrypt.user_data : '',
      log_status: userInfoEncrypt.log_status,
    })
  }

  const dataLayerModalErrorButton = () => {
    const userInfoEncrypt = encryptUserInfo()
    pushDataLayerEvent({
      event: 'Interacciones_Pop-ups_VConfident',
      category: 'v-confident',
      action: 'click',
      label: 'Ir a NosotrasOnline.com',
      location: typeof window !== 'undefined' ? window.location.href : '',
      user_data: userInfoEncrypt.user_data ? userInfoEncrypt.user_data : '',
      log_status: userInfoEncrypt.log_status,
    })
  }

  useEffect(() => {
    dataLayerModalError()
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'ga_event',
      category: 'V-Confident :: Muestra Gratis',
      action: 'Pedir Muestra :: PopUp',
      label: 'Aún no has llegado a esta etapa de tu vida',
      value: '',
    })
  }, [])

  return (
    <ModalDialog
      image={content[0].imagenComponente[0]}
      onClose={onClose}
      content={
        <div className="f-modal-error-age">
          {documentToReactComponents(
            JSON.parse(content[0].descripcinComponente.raw),
            {
              renderNode: {
                [BLOCKS.PARAGRAPH]: (_, children) => (
                  <p className="f-modal-error-age__description">{children}</p>
                ),
              },
            }
          )}
          <Button
            text={content[0].botonComponente}
            color="purple"
            action={() => {
              dataLayerModalErrorButton()
              window.location.href = baseSiteUrl
            }}
          />
        </div>
      }
    />
  )
}

export default ModalAgeError
